@if (loading() || error()) {
  <app-modal-loading-section
    message="modals.errors.delegation"
    [loading]="loading()"
    [(error)]="error"
    (errorChange)="delegation$.next()"
  ></app-modal-loading-section>
} @else if (isDelegationActive() && delegation(); as delegation) {
  <app-delegation-period
    [start]="delegation.start"
    [end]="delegation.end"
    [status]="delegation.status.value"
    [clickable]="true"
    heading="labels.activeDelegation"
    [identifier]="delegation.identifier"
    [relatedFleetSwap]="delegation.relatedFleetSwap"
    (edit)="editDelegation()"
    (openDelegationModal)="openDelegationModal()"
    (openDelegationActionModal)="openDelegationActionModal()"
  ></app-delegation-period>
} @else {
  <onyx-information-heading>
    {{ 'modals.noActiveDelegation' | translate }}

    <onyx-icon-button
      actions
      variant="transparent"
      color="gray"
      [size]="32"
      icon="zoom-in-outlined"
      [circle]="true"
      [disabled]="isArchived()"
      [onyxTooltip]="!isArchived() ? 'labels.create' : null"
      (click)="!isArchived() ? addDelegation.emit() : null"
    ></onyx-icon-button>
  </onyx-information-heading>
}
